export default function BCPSuccessionPlanningDirective() {
  return {
    template: require('./bcp-succession-planning.html'),
    scope: {
      assessmentId: '=',
      status: '='
    },
    controller: 'BCPSuccessionPlanningController',
    controllerAs: 'bcpSuccessionPlanningVM',
    bindToController: true,
    replace: true,
  };
}
